import React from 'react';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';
import { credit_card } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Panel_G04_SplitPaymentToCreditManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultPanelManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
    manualName={credit_card}
  />
);

export default Panel_G04_SplitPaymentToCreditManually;
